export class Utente {
  codDitta: string;
  username: string;
  livello: number; //Indica il tipo del ruolo
  infoDitta: InfoDitta;
  password?: string;
  nomeEntraId?: string;
  objectId?: string;
  escludiPolicyPassword: boolean;
  utenteBloccato: boolean;
  tentativiPasswordErrata: number;
  ruoloString?: string;
  idsReparti?: string;
}

export class InfoDitta {
  denominazione: string;
  dettagliGrafici: DettagliGrafici;
} 

export class DettagliGrafici {
  pathLogo: string;
}

